import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  TextField,
  TableBody,
  TableCell,
  Container,
  Typography,
  Grid,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
} from "@mui/material";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { get, post } from "src/utils/networkUtils";

export default function GameCodesPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [campaignName, setCampaignName] = useState(null);
  const [codesCount, setCodesCount] = useState(null);
  const [rows, setRows] = useState(null);
  const [game, setGame] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has("game_id")) {
      let gameId = searchParams.get("game_id");
      setGame(gameId);
      get(`/admin/game/${gameId}/codes`).then(function (response) {
        setRows(response.codesPerCampaign);
      });
    } else {
      navigate("/404");
    }
  }, [setSearchParams, searchParams, navigate]);

  const handleGenerateGameCodes = () => {
    setLoading(true);

    post(`/admin/game/${game}/generate-codes`, {
      size: codesCount,
      campaign: campaignName,
    })
      .then(function (response) {
        window.location.reload(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleCampaignNameChange = (e) => {
    const { value } = e.target;
    setCampaignName(value);
  };
  const handleCodesCountChange = (e) => {
    const { value } = e.target;
    setCodesCount(value);
  };
  return (
    <>
      <Helmet>
        <title> Bingo Game Codes </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Game Codes
          </Typography>
          <Box></Box>
        </Stack>
        <Box sx={{ m: 1, mb: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                id="campaign"
                label="Campaign Name"
                type="text"
                fullWidth
                value={campaignName}
                variant="standard"
                onChange={handleCampaignNameChange}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                id="size"
                label="Number of codes"
                type="text"
                fullWidth
                value={codesCount}
                variant="standard"
                onChange={handleCodesCountChange}
              />
            </Grid>
            <Grid item xs={3}>
              <Button
                sx={{ mr: 2 }}
                variant="contained"
                startIcon={<Iconify icon="eva:flip-2-outline" />}
                onClick={() => handleGenerateGameCodes()}
                disabled={
                  campaignName === null ||
                  campaignName.length < 4 ||
                  codesCount === null ||
                  codesCount < 1
                }
              >
                Generate codes
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Campaign</TableCell>
                      <TableCell>Codes</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {index + 1}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.CampaignName}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.CodesCount}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={
                              <Iconify icon="eva:arrow-circle-down-outline" />
                            }
                            onClick={() =>
                              window.open(
                                `${process.env.REACT_APP_API_BASE_URL}/admin/game/${game}/download-codes?campaign=${row.CampaignName}`,
                                "_blank",
                                "noreferrer"
                              )
                            }
                          >
                            Download codes
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
    </>
  );
}
